var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "home flex-nowrap",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('div', {
    staticClass: "left-column flex-grow-1 flex-shrink-1"
  }, [_c('div', {
    staticClass: "navigation"
  }, [_c('router-view', {
    attrs: {
      "name": "navigation"
    }
  })], 1), _vm.initialized ? _c('div', {
    staticClass: "main-ctn flex-shrink-1 flex-grow-1"
  }, [_vm.currentRouteName !== 'config-global' ? _c('ControlBar') : _vm._e(), _c('keep-alive', [_c('router-view', {
    attrs: {
      "name": "tab"
    }
  })], 1)], 1) : _vm._e()]), _vm.isCampaignLoaded && _vm.isLandingPageConfigLoaded ? _c('div', {
    staticClass: "preview-ctn flex-shrink-0 flex-grow-1 max-width-400",
    class: {
      'full-screen': _vm.isPreviewFullScreen
    }
  }, [_vm.currentRouteName === 'config-auth-app-branding' ? _c('auth-preview', {
    attrs: {
      "fullscreen": _vm.isPreviewFullScreen
    }
  }) : _c('preview', {
    attrs: {
      "mode": "remote",
      "fullscreen": _vm.isPreviewFullScreen
    }
  })], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }